<template>
	<v-app id="zarinpalCallback-view" fluid tag="section">
		<v-app-bar color="secondary" dark dense style="max-height: 48px">
			<v-toolbar-title>
				<img src="/logo-wide.png" style="float: right;max-width: 100px;max-height: 50px;" />
				<strong class="mr-1 font-weight-black">بررسی اطلاعات جهت هدایت به درگاه پرداخت</strong>
				&nbsp;
				<span class="warning--text">{{ longTitle }}</span>
			</v-toolbar-title>
		</v-app-bar>
		<v-container>
			<v-row justify="center" class="my-12">
				<v-col cols="12" md="6" v-if="loading || !isSuccess">
					<v-card class="mx-auto">
						<div class="d-flex flex-column justify-center align-center" style="height:200px;" :style="{ 'background-color': bg }">
							<v-icon size="large" :color="color" style="font-size: 100px;">
								{{ icon }}
							</v-icon>
						</div>
						<div class="form-group text-center pa-5">
							<div v-if="message" v-html="message">

							</div>
						</div>
					</v-card>
				</v-col>
			</v-row>
			<v-row class="justify-center" justify="center" v-if="!loading && isSuccess">
				<v-col cols="12" md="6">
					<v-card color="white" class="">
						<div class="form-group text-right pa-5">
							<div class="text-center pa-5">
								<v-btn fab color="secondary" elevation="0" x-large>
									<v-icon color="white">mdi-wallet-outline</v-icon>
								</v-btn>
							</div>
							<p class="text-body secondary--text" style="text-align: justify;">کاربر گرامی شما در حال آماده سازی جهت شارژ کیف پول با مشخصات زیر هستید، لطفا پس از بررسی و اطمینان از صحت اطلاعات اقدام به پرداخت نمایید.</p>
							<div class="my-2">
								<span>پذیرنده:</span><span class="grey--text mr-2">{{ data.customer }}</span>
							</div>
							<div class="my-2">
								<span>مشخصات شما:</span><span class="grey--text mr-2">{{ data.member }}</span>
							</div>
							<v-divider />
							<div class="px-3 pt-3 rtl">
								<v-form ref="form" class="mx-2" lazy-validation @submit.prevent="submit">
									<v-text-money outline style="direction: rtl" hint="حداقل مبلغ شارژ 80 هزار تومان می باشد" persistent-hint class="align-center rtl" v-model="amount" label="مبلغ مورد نظر جهت شارژ (تومان):" :error-messages="errorMessages" :rules="[() => amount >= 80000 || 'حداقل مبلغ شارژ رعایت نشده است']" required />
									<div class="pt-5 text-center">
										<v-btn @click="submit" color="secondary" class="w-100" :loading="submitLoading">
											<v-icon class="ml-2">mdi-credit-card</v-icon>
											پرداخت آنلاین
										</v-btn>
									</div>
								</v-form>
							</div>
						</div>
					</v-card>

				</v-col>
			</v-row>
		</v-container>
	</v-app>
</template>

<script>
	import OnlinePayment from '@/components/forms/OnlinePayment.vue'
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import ThemeManager from '@/util/theme-manager.js'
	import toast from '@/util/toast'

	const INVALIDMSG = 'اطلاعات معتبر نمی باشد'
	export default {
		name: 'PreOnlinePayment',
		components: {
			'online-payment': OnlinePayment,
		},
		data() {
			return {
				userLoanPayment: null,
				errorMessages: '',
				data: { customer: '', customerCode: 0, member: '', memberId: 0 },
				submitLoading: false,
				loading: false,
				isSuccess: null,
				message: '',
				amount: 0,
			}
		},
		computed: {
			...get('siteConfig', [
				'longTitle'
			]),
			...get('memberAppSettings', [
				'iceOnlinePaymentGateway'
			]),
			bg() {
				if (this.loading)
					return '#dadada'
				if (this.isSuccess)
					return 'rgb(182 255 193)'
				return 'rgb(255 227 227)'
			},
			color() {
				if (this.loading)
					return '#aaa'
				if (this.isSuccess)
					return '#0dd400'
				return '#ff5722'
			},
			icon() {
				if (this.loading)
					return 'mdi-timer-sand'
				if (this.isSuccess)
					return 'mdi-credit-card-check'
				return 'mdi-alert-circle-outline'
			},
			title() {
				if (this.loading)
					return 'در حال بررسی'
				if (this.isSuccess)
					return 'پرداخت موفق'
				return 'پرداخت ناموفق'
			}
		},
		created() {
			// ThemeManager.ApplyThemeSettings(this.$route.params.customerCode || 0, this.$vuetify)
		},
		mounted() {
			if (!this.$route.query.ccode || !this.$route.query.mid) {
				this.message = INVALIDMSG
				return
			}
			this.verify()
			this.amount = 80000
		},
		methods: {
			verify() {
				this.message = 'در حال دریافت اطلاعات، لطفا تا پایان عملیات منتظر بمانید...'
				this.loading = true
				let data = {
					customerCode: this.$route.query.ccode,
					memberId: this.$route.query.mid
				}
				api.post('memberPurchase/WalletCharge', data, { authHeader: false, contentType: 'application/json' })
					.then(response => {
						this.isSuccess = true
						this.data.customer = response.customer
						this.data.member = response.member
						this.data.memberId = response.memberId
						this.data.customerCode = response.customerCode
					})
					.catch(error => {
						this.isSuccess = false
						this.message = error.message || error.toString()
					})
					.finally(() => {
						this.loading = false
					})
			},
			returnToPanel() {
				this.$router.push('/member/dashboard')
			},
			submit() {
				if (!this.$refs.form.validate()) { return }
				this.submitLoading = true
				let data = {
					amount: this.amount,
					memberPurchaseType: 1,
					paymentMethod: this.iceOnlinePaymentGateway,
					user: { id: this.data.memberId },
					customerCode: this.data.customerCode
				}
				api.post('memberpurchase/create', data, { authHeader: false, contentType: 'application/json' })
					.then(response => {
						if (response.gateway === 'sep') {
							let form = document.getElementById('sepForm')
							let sepToken = document.getElementById('sepToken')
							sepToken.value = response.token
							form.submit()
						}
						else {
							window.location.replace(response.gatewayUrl)
						}
					})
					.catch(err => {
						this.submitLoading = false
						toast.error(err.message)
					})
			}
		},
	}
</script>

<style scoped></style>
